import { WorkingWidthRowsPositions } from './workingWidthRowsPositions';
import { User } from './user';
import { EquipmentActivity } from './equipmentActivity';
import { ToolLastState } from './machinaries/toolLastState';
import { TenantGeneralData } from './tenantGeneralData';
import { SilosLastState } from './silosLastState';

export class Equipment extends TenantGeneralData {
  id: number;
  type: string;
  name: string;
  description: string;
  manufacturer: string;
  model: string;
  power: string;
  powerUnit: 'kw';
  year: number;
  licencePlate: string;
  frame: string;
  manager: User;
  imgUrl: string;
  iconUrl?: Array<any>;
  data?: Array<any>;
  attachmentUrl: string;
  attachmentUrls: Array<Document>;
  dateOfPurchase: Date;
  inspectionDate: Date;
  technicalCheckDate: Date;
  attachmentRegistrationDocUrl: string; // Libretto di circolazione
  attachmentInsuranceDocUrl: string; // Assicurazione
  attachmentManualDocUrl: string;
  activities: Array<EquipmentActivity>;
  disabled: boolean;
  sold: boolean;
  soldAmount: number;
  lastSyncLat: number;
  lastSyncLng: number;
  lastSyncDate: Date;
  externalSerialNumber: string = null;
  positionType: number = null;
  operationType: string = null;
  isOn: boolean;
  tankCapacity: number;
  tankFuelLevel: number;
  percentageFuelLevel?: number;

  silosLastState: SilosLastState;

  fieldActivityAutoCreate: boolean = false;
  equipmentTemplateId: number = null;
  toolLastState: ToolLastState;
  workingWidthMeters: number = null;
  deviceOffsetX: number = null;
  deviceOffsetY: number = null;
  workingWidthRowsPositions: WorkingWidthRowsPositions = null;
  // Agrirouter
  agrirouterRawContentURL: string;
  toolConfiguration: any; // todo
  matriculationDate: Date;
  expectedLifeYears: number;
  metaData: Array<any>;
  companyName?: string;
  registerNumberROMA: string = null;
  rented: boolean = null;
  calibrationId?: string = null;

  constructor() {
    super();
    this.id = null;
    this.type = null;
    this.name = null;
    this.description = null;
    this.manufacturer = null;
    this.model = null;
    this.power = null;
    this.powerUnit = null;
    this.year = null;
    this.licencePlate = null;
    this.frame = null;
    this.manager = null;
    this.imgUrl = null;
    this.dateOfPurchase = null;
    this.inspectionDate = null;
    this.technicalCheckDate = null;
    this.attachmentRegistrationDocUrl = null;
    this.attachmentInsuranceDocUrl = null;
    this.attachmentManualDocUrl = null;
    this.attachmentUrl = null;
    this.attachmentUrls = null;
    this.activities = null;
    this.disabled = null;
    this.sold = null;
    this.soldAmount = null;
    // this.externalId = null;
    // this.externalSource = null;
    this.lastSyncLat = null;
    this.lastSyncLng = null;
    this.lastSyncDate = null;
    this.externalSerialNumber = null;
    this.positionType = null;
    this.operationType = null;
    this.isOn = null;
    this.tankFuelLevel = null;
    this.silosLastState = null;
    this.fieldActivityAutoCreate = false;
    this.equipmentTemplateId = null;
    this.toolLastState = null;
    this.workingWidthMeters = null;
    this.deviceOffsetX = null;
    this.deviceOffsetY = null;
    this.workingWidthRowsPositions = null;
    this.toolConfiguration = null;
    this.matriculationDate = null;
    this.expectedLifeYears = null;
    this.metaData = null;
    this.registerNumberROMA = null;
    this.rented = null;
    this.calibrationId = null;
  }
}
/*
*********** MODELLO DI BACKEND **********************

package com.xfarm.api.v1.core

import com.xfarm.api.v1.auth.User

class Equipment {

    transient springSecurityService

    Long    companyId = -1
    string  type
    string  name
    string  description
    string  manufacturer
    string  model
    string  power
    string  powerUnit = "kw"
    Integer year
    string  licencePlate
    string  frame
    User    manager
    string  imgUrl
    string  attachmentUrl
    Date    dateOfPurchase
    Date    inspectionDate
    Date    technicalCheckDate
    string  attachmentRegistrationDocUrl    // Libretto di circolazione
    string  attachmentInsuranceDocUrl       // Assicurazione
    string  attachmentManualDocUrl          // Manuale

    Date    dateCreated
    Date    lastUpdated

    static hasMany = [activities: EquipmentActivity]


    static constraints = {
        companyId       blank: false
        type            blank: false, nullable: false, inList: ["tractor", "trailer", "seeder", "fertilizer", "plow", "harrow",
                                                                "sprayer", "milling_machine", "disk_harrow","hoeing_machine",
                                                                "press_roll", "shredder", "stocking", "irrigation", "baler",
                                                                "mower", "tedder", "other"]
        name            blank: false, nullable: false
        description     blank: false, nullable: true
        manufacturer    blank: false, nullable: true
        model           blank: false, nullable: true
        power           blank: false, nullable: true
        powerUnit       blank: false, nullable: true, inList: ["kw", "hp"]
        year            blank: false, nullable: true, range: 1900..2100, scale: 0
        licencePlate    blank: false, nullable: true
        frame           blank: false, nullable: true
        manager         blank: false, nullable: true
        imgUrl          blank: false, nullable: true, url: true
        attachmentUrl   blank: false, nullable: true, url: true
        dateOfPurchase                  blank: false, nullable: true
        inspectionDate                  blank: false, nullable: true
        technicalCheckDate              blank: false, nullable: true
        attachmentRegistrationDocUrl    blank: false, nullable: true, url: true
        attachmentInsuranceDocUrl       blank: false, nullable: true, url: true
        attachmentManualDocUrl          blank: false, nullable: true, url: true

        dateCreated     nullable: true
        lastUpdated     nullable: true
    }
    static mapping = {
        autoTimestamp true
    }

    def beforeInsert() {
        companyId = User.get(springSecurityService?.principal?.id)?.farm?.id
    }

    def beforeUpdate() {
        if(companyId != User.get(springSecurityService?.principal?.id)?.farm?.id){
            return false
        }
    }

    static transients = ['springSecurityService']
}

*/
